(function () {
  'use strict';

  if (window.__vitHeaderInit) {
    return;
  }

  window.__vitHeaderInit = true;

  var headerWrap = document.getElementById('vitHeaderWrap');


  /* ═════════════════════════════════════
     FLASH SALE COUNTDOWN

     data-sale-end may contain a real ISO deadline, for example:
     2026-09-30T23:59:59+04:00

     If it is left empty, the timer counts to the visitor's local midnight.
  ═════════════════════════════════════ */

  var flashSale =
    document.getElementById(
      'vitFlashSale'
    );

  var flashHours =
    document.getElementById(
      'vitFlashHours'
    );

  var flashMinutes =
    document.getElementById(
      'vitFlashMinutes'
    );

  var flashSeconds =
    document.getElementById(
      'vitFlashSeconds'
    );

  var flashTimerInterval = null;

  function padTimer(value) {
    return String(value).padStart(2, '0');
  }

  function getFlashDeadline() {

    if (!flashSale) {
      return null;
    }

    var explicit =
      flashSale.getAttribute(
        'data-sale-end'
      );

    if (explicit) {

      var parsed =
        new Date(explicit);

      if (!isNaN(parsed.getTime())) {
        return parsed;
      }
    }

    var midnight =
      new Date();

    midnight.setHours(
      24,
      0,
      0,
      0
    );

    return midnight;
  }

  var flashDeadline =
    getFlashDeadline();

  function renderFlashCountdown() {

    if (
      !flashDeadline ||
      !flashHours ||
      !flashMinutes ||
      !flashSeconds
    ) {
      return;
    }

    var now = Date.now();
    var diff =
      flashDeadline.getTime() - now;

    if (diff <= 0) {

      var explicit =
        flashSale &&
        flashSale.getAttribute(
          'data-sale-end'
        );

      if (!explicit) {
        flashDeadline =
          getFlashDeadline();
        diff =
          flashDeadline.getTime() - now;
      } else {
        diff = 0;
      }
    }

    var totalSeconds =
      Math.max(
        0,
        Math.floor(diff / 1000)
      );

    var hours =
      Math.floor(
        totalSeconds / 3600
      );

    var minutes =
      Math.floor(
        (totalSeconds % 3600) / 60
      );

    var seconds =
      totalSeconds % 60;

    flashHours.textContent =
      padTimer(hours);

    flashMinutes.textContent =
      padTimer(minutes);

    flashSeconds.textContent =
      padTimer(seconds);
  }

  if (
    flashSale &&
    flashHours &&
    flashMinutes &&
    flashSeconds
  ) {

    renderFlashCountdown();

    flashTimerInterval =
      window.setInterval(
        renderFlashCountdown,
        1000
      );
  }

  function syncSpacer() {

    if (!headerWrap) {
      return;
    }

    /*
      IMPORTANT:
      body padding is measured from the FULL two-row header.
      When the user is mid-page, the flash-sale row collapses visually,
      but we do NOT rewrite body padding and cause a page jump.
    */
    if (
      window.pageYOffset > 10 &&
      !headerWrap.classList.contains('vit-at-top')
    ) {
      return;
    }

    var h = headerWrap.getBoundingClientRect().height;

    if (!h) {
      return;
    }

    var gap = parseFloat(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--vit-header-gap')
    ) || 0;

    document.documentElement.style.setProperty(
      '--vit-header-h',
      h + 'px'
    );

    document.body.style.setProperty(
      'padding-top',
      (h + gap) + 'px',
      'important'
    );

  }

  syncSpacer();

  if (window.ResizeObserver && headerWrap) {

    new ResizeObserver(syncSpacer).observe(
      headerWrap,
      { box: 'border-box' }
    );

  }

  window.addEventListener(
    'load',
    syncSpacer
  );

  window.addEventListener(
    'resize',
    function () {
      if (
        window.pageYOffset <= 10
      ) {
        syncSpacer();
      }
    },
    { passive: true }
  );


  if (
    document.fonts &&
    document.fonts.ready
  ) {

    document.fonts.ready
      .then(syncSpacer)
      .catch(function () {});

  }

  var lastScroll = 0;
  var scrollThreshold = 80;
  var scrollTicking = false;

  function onScroll() {

    if (!headerWrap) {
      return;
    }

    var current =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;

    var atTop =
      current <= 10;


    if (atTop) {

      /*
        Absolute top:
        FLASH + NAV stay locked together.
      */
      headerWrap.classList.add(
        'vit-at-top'
      );

      headerWrap.classList.remove(
        'vit-header-hidden'
      );

      syncSpacer();

    } else {

      /*
        Mid-page:
        FLASH SALE collapses via CSS.
        Only the NAV is allowed to become sticky on upward scroll.
      */
      headerWrap.classList.remove(
        'vit-at-top'
      );

      if (
        current > scrollThreshold &&
        current > lastScroll
      ) {

        /* Scrolling down: hide the compact navigation. */
        headerWrap.classList.add(
          'vit-header-hidden'
        );

      } else if (
        current < lastScroll
      ) {

        /* Scrolling up: reveal NAV ONLY. */
        headerWrap.classList.remove(
          'vit-header-hidden'
        );
      }
    }

    lastScroll =
      current <= 0
        ? 0
        : current;

  }

  window.addEventListener(
    'scroll',
    function () {

      if (scrollTicking) {
        return;
      }

      scrollTicking = true;

      window.requestAnimationFrame(function () {

        onScroll();

        scrollTicking = false;

      });

    },
    { passive: true }
  );

  onScroll();



  var drawer =
    document.getElementById(
      'vitDrawer'
    );

  var overlay =
    document.getElementById(
      'vitDrawerOverlay'
    );

  var openBtn =
    document.getElementById(
      'vitDrawerOpen'
    );

  var closeBtn =
    document.getElementById(
      'vitDrawerClose'
    );

  function openDrawer() {

    if (
      !drawer ||
      !overlay
    ) {
      return;
    }

    drawer.classList.add(
      'is-open'
    );

    overlay.classList.add(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    if (openBtn) {

      openBtn.setAttribute(
        'aria-expanded',
        'true'
      );

    }

    document.body.style.overflow =
      'hidden';

  }

  function closeDrawer() {

    if (
      !drawer ||
      !overlay
    ) {
      return;
    }

    drawer.classList.remove(
      'is-open'
    );

    overlay.classList.remove(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    if (openBtn) {

      openBtn.setAttribute(
        'aria-expanded',
        'false'
      );

    }

    document.body.style.overflow =
      '';

  }

  if (openBtn) {

    openBtn.addEventListener(
      'click',
      openDrawer
    );

  }

  if (closeBtn) {

    closeBtn.addEventListener(
      'click',
      closeDrawer
    );

  }

  if (overlay) {

    overlay.addEventListener(
      'click',
      closeDrawer
    );

  }

  document.addEventListener(
    'keydown',
    function (e) {

      if (
        e.key === 'Escape' &&
        drawer &&
        drawer.classList.contains('is-open')
      ) {

        closeDrawer();

      }

    }
  );

  if (drawer) {

    drawer.addEventListener(
      'click',
      function (e) {

        var link =
          e.target.closest('a');

        if (link) {
          closeDrawer();
        }

      }
    );

  }

  var countEl =
    document.getElementById(
      'vitCartCount'
    );

  var lastCount =
    countEl
      ? (
          parseInt(
            countEl.textContent,
            10
          ) || 0
        )
      : 0;

  var refreshTimer = null;
  var inFlight = false;

  function paint(count) {

    if (!countEl) {
      return;
    }

    var n =
      parseInt(
        count,
        10
      ) || 0;

    countEl.textContent = n;

    countEl.style.display =
      n > 0
        ? 'flex'
        : 'none';

    if (n > lastCount) {

      countEl.classList.remove(
        'vit-cart-bump'
      );

      void countEl.offsetWidth;

      countEl.classList.add(
        'vit-cart-bump'
      );

    }

    lastCount = n;

  }

  function refreshCartCount() {

    if (
      !countEl ||
      inFlight
    ) {
      return;
    }

    inFlight = true;

    fetch(
      '/cart.js?vit=' + Date.now(),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'application/json'
        }
      }
    )

      .then(function (r) {

        return r.ok
          ? r.json()
          : null;

      })

      .then(function (cart) {

        if (
          cart &&
          typeof cart.item_count !==
            'undefined'
        ) {

          paint(
            cart.item_count
          );

        }

      })

      .catch(function () {})

      .then(function () {

        inFlight = false;

      });

  }

  function scheduleRefresh(delay) {

    clearTimeout(
      refreshTimer
    );

    refreshTimer =
      setTimeout(
        refreshCartCount,
        typeof delay === 'number'
          ? delay
          : 120
      );

  }

  function isCartWrite(url) {

    if (!url) {
      return false;
    }

    var u =
      String(url);

    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(
      u
    );

  }

  if (
    typeof window.fetch ===
    'function'
  ) {

    var nativeFetch =
      window.fetch;

    window.fetch =
      function () {

        var url =
          arguments[0];

        if (
          url &&
          typeof url === 'object' &&
          url.url
        ) {

          url = url.url;

        }

        var result =
          nativeFetch.apply(
            this,
            arguments
          );

        if (
          isCartWrite(url) &&
          result &&
          typeof result.then ===
            'function'
        ) {

          result.then(
            function () {
              scheduleRefresh();
            },
            function () {
              scheduleRefresh();
            }
          );

        }

        return result;

      };

  }

  if (
    window.XMLHttpRequest &&
    XMLHttpRequest.prototype.open
  ) {

    var nativeOpen =
      XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open =
      function (method, url) {

        if (
          isCartWrite(url)
        ) {

          this.addEventListener(
            'loadend',
            function () {
              scheduleRefresh();
            }
          );

        }

        return nativeOpen.apply(
          this,
          arguments
        );

      };

  }

  [
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'cart:build',
    'cart:added',
    'cart-updated',
    'cartUpdated',
    'ajaxCart.afterCartLoad',
    'shopify:cart:updated',
    'kaching:cart:updated',
    'vit:cart:updated'
  ].forEach(function (name) {

    document.addEventListener(
      name,
      function () {
        scheduleRefresh();
      }
    );

    window.addEventListener(
      name,
      function () {
        scheduleRefresh();
      }
    );

  });

  if (window.jQuery) {

    window.jQuery(document).on(
      'cart.requestComplete ajaxCart.afterCartLoad cart:updated',
      function () {
        scheduleRefresh();
      }
    );

  }

  window.addEventListener(
    'pageshow',
    function (e) {

      if (e.persisted) {

        scheduleRefresh(0);
        syncSpacer();

      }

    }
  );

  document.addEventListener(
    'visibilitychange',
    function () {

      if (!document.hidden) {
        scheduleRefresh(0);
      }

    }
  );

  window.addEventListener(
    'focus',
    function () {
      scheduleRefresh(400);
    }
  );

  scheduleRefresh(0);

  window.vitRefreshCartCount =
    refreshCartCount;

  function syncNomadGift(cart) {

    var nomadGift =
      document.querySelector(
        '#vitCart [data-gift="nomad"]'
      );

    if (!nomadGift || !cart || !cart.items) {
      return;
    }

    var packs = 0;

    cart.items.forEach(function (item) {
      if (item.variant_id === 58640337174902) {
        packs += item.quantity;
      }
    });

    nomadGift.classList.toggle(
      'is-locked',
      packs < 3
    );
  }

  document.addEventListener(
    'vit:cart:updated',
    function (event) {
      if (event.detail) {
        syncNomadGift(event.detail);
      }
    }
  );

  var cartLink =
    document.getElementById(
      'vitCartLink'
    );

  if (cartLink) {

    cartLink.addEventListener(
      'click',
      function (e) {

        if (
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.button !== 0
        ) {
          return;
        }

        if (
          typeof window.vitCartOpen !==
          'function'
        ) {
          return;
        }

        e.preventDefault();

        window.vitCartOpen();

      }
    );

  }

  var giftsToggle=document.getElementById('vitCartGiftsToggle');
  var giftsBox=document.getElementById('vitCartGifts');
  if(giftsToggle&&giftsBox){
    giftsToggle.addEventListener('click',function(){
      var expanded=giftsBox.classList.toggle('is-expanded');
      giftsToggle.setAttribute('aria-expanded',expanded?'true':'false');
    });
  }

  var protectToggle=document.getElementById('vitProtectToggle'),protectOptOut=false,protectSyncing=false;
  if(protectToggle){
    protectToggle.checked=true;
    protectToggle.addEventListener('change',function(){protectOptOut=!this.checked;});
  }
  function ensureDefaultProtection(cart){
    if(protectOptOut||protectSyncing||!cart||!cart.items)return;
    var packs=0,hasProtection=false;
    cart.items.forEach(function(item){
      if(item.variant_id===58640337174902)packs+=item.quantity;
      if(item.variant_id===58695971242358&&item.quantity>0)hasProtection=true;
    });
    if(packs>0&&protectToggle)protectToggle.checked=true;
    if(packs<1||hasProtection)return;
    protectSyncing=true;
    fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:{58695971242358:1}})})
      .then(function(r){return r.ok?r.json():Promise.reject();})
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('vit:cart:updated',{detail:cart}));
        if(typeof window.vitCartRefresh==='function')window.vitCartRefresh();
      })
      .catch(function(){})
      .then(function(){protectSyncing=false;});
  }
  document.addEventListener('vit:cart:updated',function(e){ensureDefaultProtection(e.detail);});
  document.addEventListener('DOMContentLoaded',function(){
    fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():null;}).then(ensureDefaultProtection).catch(function(){});
  });

})();
